import { ContentType, GenericHttpClient, GenericHttpResult, HttpMethod, HttpResContentKind, RequestParams } from '@agunity/api-v4';
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError, Method } from 'axios';
import { apiUrl } from './environments';

/**
 * Http request axios
 *
 * This should be moved to the project where it is needed.
 * This would allow us to remove the Axios lib from the dependencies (leave in dev for testing)
 */

export class AxiosHttpClient implements GenericHttpClient {
  // eslint-disable-next-line no-unused-vars
  onError?: <T>(err: Error) => GenericHttpResult<T>;

  request<T>({
    url,
    method,
    body,
    query,
    type,
    format,
    params,
  }: {
    url: string;
    method: HttpMethod;
    body?: any;
    query?: any;
    type?: ContentType;
    format?: HttpResContentKind;
    params: RequestParams;
  }): Promise<GenericHttpResult<T>> {
    const options: AxiosRequestConfig = {
      method: method.toLowerCase() as Method,
      headers: params.headers,
      url: apiUrl + url,
      data: body,
      decompress: false, // you might want to test this
      // transformRequest: [function(data, headers) {
      //   // Do whatever you want to transform the data

      //   return data;
      // }],
    };

    if (format) {
      switch (format) {
        case 'json':
          options.responseType = 'json';
          break;
        case 'blob':
          options.responseType = 'blob';
          break;
        case 'other':
          options.responseType = 'text'; // or 'arraybuffer' or any other valid responseType
          break;
        case 'formData':
          // Axios doesn't support 'formData' as a responseType, you might need to handle this case differently
          break;
        case 'document':
          options.responseType = 'document';
          break;
        default:
          options.responseType = 'json';
          break;
      }
    }

    return axios
      .request(options)
      .then((resp: AxiosResponse<T>) => {
        const result: GenericHttpResult<T> = {
          data: resp.data,
          status: resp.status,
          headers: resp.headers as { [key: string]: string },
        };
        return result;
      })
      .catch(async (error: AxiosError) => {
        if (error.request.responseType === 'blob' && error.response?.data instanceof Blob) {
          error.response.data = JSON.parse(await error.response.data.text()); // Convert Blob to JSON
        }
        if (this.onError) {
          return this.onError<T>(error);
        } else {
          throw error;
        }
      });
  }
}
